<template>
    <div class="rulerManagement fadeInRight">
        <div class="title-box clearfix">
            <span class="m-title">扣费规则管理</span>
            <el-form
                :inline="true"
                :model="formInline"
                class="right themed-form search-form"
                style="height: auto; line-height: 40px"
            >
                <el-form-item label="规则名称:">
                    <el-input
                        v-model="formInline.name"
                        placeholder="规则名称"
                        clearable
                    ></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button
                        type="primary"
                        @click="searchData"
                        icon="el-icon-search"
                        class="themed-button"
                        >搜索</el-button
                    >
                </el-form-item>

                <el-form-item>
                    <el-button
                        type="primary"
                        @click="addRuler"
                        icon="el-icon-plus"
                        class="themed-button"
                        >新增规则</el-button
                    >
                </el-form-item>
            </el-form>
        </div>
        <div class="content-box">
            <el-table
                :data="tabledata"
                stripe
                style="width: 100%"
                border
                ref="table"
                :max-height="maxTableHeight"
            >
                <el-table-column prop="name" label="规则名称">
                </el-table-column>
                <el-table-column prop="type" label="类型">
                    <template slot-scope="scope">
                        <span v-if="scope.row.type == '1'">线性</span>
                        <span v-else-if="scope.row.type == '2'">阶梯</span>
                    </template>
                </el-table-column>
                <el-table-column prop="category" label="规则类型">
                    <template slot-scope="scope">
                        <span v-if="scope.row.category == 0">默认</span>
                        <span v-else-if="scope.row.category == 1">卡池组</span>
                        <span v-else>-</span>
                    </template>
                </el-table-column>
                <el-table-column
                    label="折扣"
                    prop="discount"
                    show-overflow-tooltip
                >
                    <template slot-scope="scope">
                        <!-- <el-input v-if="scope.row.distributionStatus == 1"   v-model="scope.row.agentOrder" @change="((val)=>{updateSort(val,scope.row.agentSetMealId,1)})"></el-input> -->
                        <el-input-number
                            v-model="scope.row.discount"
                            :precision="4"
                            :min="0.0001"
                            :step="0.1"
                            :max="1"
                            @change="
                                (val) => {
                                    updateDiscount(val, scope.row.id);
                                }
                            "
                        ></el-input-number>
                    </template>
                </el-table-column>
                <el-table-column prop="addFlow" label="流量(G)">
                    <template v-slot:default="scope">
                        <span v-if="scope.row.type == 1">{{
                            scope.row.addFlow
                        }}</span>
                        <span v-else>-</span>
                    </template>
                </el-table-column>
                <el-table-column prop="deductMoney" label="扣费(元)">
                    <template v-slot:default="scope">
                        <span v-if="scope.row.type == 1">{{
                            scope.row.deductMoney
                        }}</span>
                        <span v-else>-</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="320px">
                    <template v-slot:default="scope">
                        <el-button
                            type="info"
                            class="themed-button"
                            @click="getDetail(scope.row)"
                            v-if="scope.row.type == 2"
                            >规则详情</el-button
                        >
                        <el-button
                            type="info"
                            class="themed-button"
                            @click="copy(scope.row)"
                            >复制</el-button
                        >
                        <el-button
                            type="info"
                            class="themed-button"
                            @click="deleteData(scope.row.id)"
                            >删除</el-button
                        >
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                :current-page.sync="page"
                :page-sizes="[10, 15, 25, 100]"
                :page-size="pageSize"
                style="text-align: left; margin-top: 20px"
                background
                layout="total,sizes,prev, pager, next,jumper"
                :total="total"
                @size-change="handleSizeChange"
                @current-change="onPageChange"
            >
            </el-pagination>
        </div>
        <el-dialog
            title="新建规则"
            :visible.sync="dialogAddVisible"
            v-if="dialogAddVisible"
        >
            <el-form :model="addForm" :rules="rules" ref="addForm">
                <el-form-item
                    label="规则类型"
                    :label-width="formLabelWidth"
                    prop="category"
                >
                    <el-radio-group
                        v-model="addForm.category"
                        @change="onCategoryChange"
                    >
                        <el-radio :label="0">默认</el-radio>
                        <el-radio :label="1">卡池组</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item
                    label="名称"
                    :label-width="formLabelWidth"
                    prop="name"
                    required
                >
                    <el-input
                        v-model="addForm.name"
                        autocomplete="off"
                    ></el-input>
                </el-form-item>

                <!-- 卡池组规则类型时显示代理商选择 -->
                <el-form-item
                    v-if="addForm.category == 1"
                    label="代理商"
                    :label-width="formLabelWidth"
                    prop="agentId"
                >
                    <el-select
                        v-model="addForm.agentId"
                        filterable
                        placeholder="请选择代理商"
                        clearable
                    >
                        <el-option
                            v-for="(item, index) in agentLists"
                            :key="index"
                            :label="item.label"
                            :value="item.value"
                        ></el-option>
                    </el-select>
                </el-form-item>

                <!-- 默认规则类型时显示这些字段 -->
                <template v-if="addForm.category == 0">
                    <el-form-item
                        label="类型"
                        :label-width="formLabelWidth"
                        prop="type"
                    >
                        <el-select v-model="addForm.type">
                            <el-option label="线性" value="1"></el-option>
                            <el-option label="阶梯" value="2"></el-option>
                        </el-select>
                    </el-form-item>

                    <!-- 线性规则特有字段 -->
                    <template v-if="addForm.type == 1">
                        <el-form-item
                            label="流量(G)"
                            :label-width="formLabelWidth"
                            prop="addFlow"
                        >
                            <el-input-number
                                v-model="addForm.addFlow"
                                :precision="2"
                                :min="0"
                                :step="0.1"
                                placeholder="请输入流量"
                            ></el-input-number>
                        </el-form-item>

                        <el-form-item
                            label="扣费(元)"
                            :label-width="formLabelWidth"
                            prop="deductMoney"
                        >
                            <el-input-number
                                v-model="addForm.deductMoney"
                                :precision="2"
                                :min="0"
                                :step="0.01"
                                placeholder="请输入扣费金额"
                            ></el-input-number>
                        </el-form-item>
                    </template>

                    <el-form-item
                        label="阶梯详细:"
                        :label-width="formLabelWidth"
                        v-if="addForm.type == 2"
                    >
                        <el-button
                            type="primary"
                            class="themed-button leftMar"
                            @click="showAddPrice"
                            >阶梯资费设置</el-button
                        >
                    </el-form-item>

                    <el-form-item
                        label="折扣"
                        :label-width="formLabelWidth"
                        prop="discount"
                    >
                        <el-input-number
                            v-model="addForm.discount"
                            :precision="4"
                            :min="0.0001"
                            :step="0.1"
                            :max="1"
                        ></el-input-number>
                    </el-form-item>
                </template>
                <!-- 规则列表 -->
                <div
                    v-if="
                        addForm.category == 1 &&
                        addForm.ruleDetail &&
                        addForm.ruleDetail.length > 0
                    "
                >
                    <!-- 新增的规则（从规则2开始） -->
                    <div
                        v-for="(rule, index) in addForm.ruleDetail"
                        :key="index"
                        class="rule-item"
                    >
                        <el-divider content-position="left"
                            >规则 {{ index + 1 }}</el-divider
                        >

                        <el-form-item
                            :label="'类型'"
                            :label-width="formLabelWidth"
                        >
                            <el-select v-model="rule.type" style="width: 120px">
                                <el-option label="线性" value="1"></el-option>
                                <el-option label="阶梯" value="2"></el-option>
                            </el-select>
                        </el-form-item>

                        <el-form-item
                            :label="'折扣'"
                            :label-width="formLabelWidth"
                        >
                            <el-input-number
                                v-model="rule.discount"
                                :precision="4"
                                :min="0.0001"
                                :step="0.1"
                                :max="1"
                                style="width: 120px"
                            ></el-input-number>
                        </el-form-item>

                        <el-form-item
                            :label="'省份'"
                            :label-width="formLabelWidth"
                        >
                            <el-select
                                v-model="rule.province"
                                placeholder="请选择省份"
                                clearable
                                style="width: 150px"
                            >
                                <el-option label="全国" value="0"></el-option>
                                <el-option
                                    label="北京市"
                                    value="110000"
                                ></el-option>
                                <el-option
                                    label="天津市"
                                    value="120000"
                                ></el-option>
                                <el-option
                                    label="河北省"
                                    value="130000"
                                ></el-option>
                                <el-option
                                    label="山西省"
                                    value="140000"
                                ></el-option>
                                <el-option
                                    label="内蒙古自治区"
                                    value="150000"
                                ></el-option>
                                <el-option
                                    label="辽宁省"
                                    value="210000"
                                ></el-option>
                                <el-option
                                    label="吉林省"
                                    value="220000"
                                ></el-option>
                                <el-option
                                    label="黑龙江省"
                                    value="230000"
                                ></el-option>
                                <el-option
                                    label="上海市"
                                    value="310000"
                                ></el-option>
                                <el-option
                                    label="江苏省"
                                    value="320000"
                                ></el-option>
                                <el-option
                                    label="浙江省"
                                    value="330000"
                                ></el-option>
                                <el-option
                                    label="安徽省"
                                    value="340000"
                                ></el-option>
                                <el-option
                                    label="福建省"
                                    value="350000"
                                ></el-option>
                                <el-option
                                    label="江西省"
                                    value="360000"
                                ></el-option>
                                <el-option
                                    label="山东省"
                                    value="370000"
                                ></el-option>
                                <el-option
                                    label="河南省"
                                    value="410000"
                                ></el-option>
                                <el-option
                                    label="湖北省"
                                    value="420000"
                                ></el-option>
                                <el-option
                                    label="湖南省"
                                    value="430000"
                                ></el-option>
                                <el-option
                                    label="广东省"
                                    value="440000"
                                ></el-option>
                                <el-option
                                    label="广西壮族自治区"
                                    value="450000"
                                ></el-option>
                                <el-option
                                    label="海南省"
                                    value="460000"
                                ></el-option>
                                <el-option
                                    label="重庆市"
                                    value="500000"
                                ></el-option>
                                <el-option
                                    label="四川省"
                                    value="510000"
                                ></el-option>
                                <el-option
                                    label="贵州省"
                                    value="520000"
                                ></el-option>
                                <el-option
                                    label="云南省"
                                    value="530000"
                                ></el-option>
                                <el-option
                                    label="西藏自治区"
                                    value="540000"
                                ></el-option>
                                <el-option
                                    label="陕西省"
                                    value="610000"
                                ></el-option>
                                <el-option
                                    label="甘肃省"
                                    value="620000"
                                ></el-option>
                                <el-option
                                    label="青海省"
                                    value="630000"
                                ></el-option>
                                <el-option
                                    label="宁夏回族自治区"
                                    value="640000"
                                ></el-option>
                                <el-option
                                    label="新疆维吾尔自治区"
                                    value="650000"
                                ></el-option>
                                <el-option
                                    label="台湾省"
                                    value="710000"
                                ></el-option>
                                <el-option
                                    label="香港特别行政区"
                                    value="810000"
                                ></el-option>
                                <el-option
                                    label="澳门特别行政区"
                                    value="820000"
                                ></el-option>
                            </el-select>
                        </el-form-item>

                        <!-- 线性规则特有字段 -->
                        <template v-if="rule.type == 1">
                            <el-form-item
                                :label="'流量(G)'"
                                :label-width="formLabelWidth"
                            >
                                <el-input-number
                                    v-model="rule.addFlow"
                                    :precision="2"
                                    :min="0"
                                    :step="0.1"
                                    placeholder="请输入流量"
                                    style="width: 120px"
                                ></el-input-number>
                            </el-form-item>

                            <el-form-item
                                :label="'扣费(元)'"
                                :label-width="formLabelWidth"
                            >
                                <el-input-number
                                    v-model="rule.deductMoney"
                                    :precision="2"
                                    :min="0"
                                    :step="0.01"
                                    placeholder="请输入扣费金额"
                                    style="width: 120px"
                                ></el-input-number>
                            </el-form-item>
                        </template>

                        <!-- 阶梯规则特有字段 -->
                        <el-form-item
                            :label="'阶梯详细'"
                            :label-width="formLabelWidth"
                            v-if="rule.type == 2"
                        >
                            <el-button
                                type="primary"
                                size="small"
                                class="themed-button"
                                @click="showLadderSetting(index)"
                                >阶梯资费设置</el-button
                            >
                        </el-form-item>

                        <!-- 删除规则按钮 -->
                        <el-form-item>
                            <div style="text-align: right">
                                <el-button
                                    type="danger"
                                    size="small"
                                    @click="removeRuleDetail(index)"
                                    icon="el-icon-delete"
                                    >删除规则</el-button
                                >
                            </div>
                        </el-form-item>
                    </div>
                </div>
                <!-- 新增规则按钮 -->
                <el-form-item v-if="addForm.category == 1">
                    <div style="text-align: right">
                        <el-button
                            type="primary"
                            size="small"
                            class="themed-button"
                            @click="addRuleDetail"
                            icon="el-icon-plus"
                            >新增规则</el-button
                        >
                    </div>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button
                    type="primary"
                    @click="formAddSubmit('addForm')"
                    class="themed-button"
                    >确 定</el-button
                >
                <el-button
                    type="primary"
                    @click="formAddReset('addForm')"
                    class="themed-button"
                    >重置</el-button
                >
                <el-button
                    type="info"
                    @click="dialogAddVisible = false"
                    class="themed-button"
                    >取 消</el-button
                >
            </div>
        </el-dialog>
        <el-dialog
            :title="isEditTitle"
            :visible.sync="dialogVisibleTwo"
            width="50%"
            v-if="dialogVisibleTwo"
            append-to-body
        >
            <ladder-setting
                @close="getladderDetail"
                :totalValue="ladderDetail"
                :isDialogAdd="isAdd"
            ></ladder-setting>
        </el-dialog>
    </div>
</template>

<script>
import onresize from "@/mixins/resize.js";
import { mapGetters } from "vuex";
import { messageBox } from "@/utils/common.js";
import {
    getRuleList,
    addRule,
    ruleDeleteById,
    updateRule,
} from "@/api/trafficPoolManagement.js";
import { getAgentForImportCard } from "@/api/cardManagement/cardImport.js";
import ladderSetting from "./ladderSetting.vue";
export default {
    name: "rulerManagement",
    mixins: [onresize],
    data() {
        return {
            page: 1,
            pageSize: 15,
            total: 0,
            formInline: {
                name: "",
            },
            tabledata: [],
            formLabelWidth: "200px",
            dialogAddVisible: false,
            addForm: {
                name: "",
                type: "2",
                discount: 1,
                category: 0,
                province: "",
                agentId: "",
                ruleDetail: [],
                ladderDetail: [],
                addFlow: "", // 新增：流量字段
                deductMoney: "", // 新增：扣费字段
            },
            dialogVisibleTwo: false,
            ladderDetail: "",
            currentRuleIndex: -1, // 当前编辑的规则索引
            agentLists: [], // 代理商列表
            rules: {
                name: [
                    {
                        required: true,
                        message: "请输入规则名称",
                        trigger: "blur",
                    },
                ],
                type: [
                    {
                        required: true,
                        message: "请选择类型",
                        trigger: "change",
                    },
                ],
                category: [
                    {
                        required: true,
                        message: "请选择规则类型",
                        trigger: "change",
                    },
                ],
                discount: [
                    {
                        required: true,
                        message: "请输入折扣",
                        trigger: "change",
                    },
                ],
                province: [
                    {
                        required: true,
                        message: "请选择省份",
                        trigger: "change",
                    },
                ],
                ruleDetail: [
                    {
                        required: true,
                        message: "请至少添加一个规则详情",
                        trigger: "change",
                    },
                ],
                addFlow: [
                    {
                        required: true,
                        message: "请输入流量",
                        trigger: "change",
                    },
                ],
                deductMoney: [
                    {
                        required: true,
                        message: "请输入扣费金额",
                        trigger: "change",
                    },
                ],
            },
            isEditTitle: "",
            isAdd: false,
        };
    },
    created() {
        this.getRuleList();
        this.getAgentForImportCard();
    },
    components: {
        ladderSetting,
    },
    computed: {
        ...mapGetters(["currentRole", "currentAgentId"]),
    },
    methods: {
        updateDiscount(val, id) {
            let postData = {
                id,
                discount: val,
            };
            updateRule(postData)
                .then((res) => {
                    this.getRuleList();
                })
                .catch((res) => {
                    messageBox(
                        this,
                        "请求错误",
                        "操作繁忙请稍后重试或联系客服。"
                    );
                });
        },
        copy(row) {
            console.log(row);
            this.dialogAddVisible = true;
            this.addForm.name = row.name + "复制";
            this.addForm.type = row.type + ""; //线性1  阶梯2
            this.addForm.discount = row.discount;
            this.addForm.category = row.category || 0; // 复制规则类型，如果没有则默认为0
            this.addForm.province = row.province || "";
            this.addForm.agentId = row.agentId || ""; // 复制代理商ID
            this.addForm.addFlow = row.addFlow || ""; // 复制流量字段
            this.addForm.deductMoney = row.deductMoney || ""; // 复制扣费字段

            // 复制规则详情
            if (row.ruleDetail) {
                try {
                    this.addForm.ruleDetail = JSON.parse(row.ruleDetail);
                    // 确保每个规则都有流量和扣费字段
                    this.addForm.ruleDetail.forEach((rule) => {
                        if (!rule.hasOwnProperty("addFlow")) {
                            rule.addFlow = "";
                        }
                        if (!rule.hasOwnProperty("deductMoney")) {
                            rule.deductMoney = "";
                        }
                    });
                } catch (e) {
                    this.addForm.ruleDetail = [];
                }
            } else {
                this.addForm.ruleDetail = [];
            }

            if (row.type == 2) {
                this.addForm.ladderDetail = row.ladderDetail; //string
            }
        },

        deleteData(id) {
            console.log(88);
            this.$confirm("是否确认删除?", "警告", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                ruleDeleteById({ id }).then((res) => {
                    this.getRuleList();
                    this.$message({
                        type: "success",
                        message: "删除成功",
                    });
                });
            });
        },
        formAddSubmit(formName) {
            //新增规则确认
            this.$refs[formName].validate((valid) => {
                console.log("addform", this.addForm);
                if (valid) {
                    let params = {};
                    params.name = this.addForm.name;
                    params.category = this.addForm.category;

                    // 如果是卡池组类型，需要验证规则详情
                    if (this.addForm.category == 1) {
                        params.agentId = this.addForm.agentId; // 添加代理商ID
                        if (
                            !this.addForm.ruleDetail ||
                            this.addForm.ruleDetail.length === 0
                        ) {
                            // 确保ruleDetail是一个数组
                            this.addForm.ruleDetail = [];

                            this.$message({
                                showClose: true,
                                message: "请至少添加一个规则详情",
                                type: "error",
                            });
                            return;
                        }

                        // 验证代理商
                        if (!this.addForm.agentId) {
                            this.$message({
                                showClose: true,
                                message: "请选择代理商",
                                type: "error",
                            });
                            return;
                        }

                        // 验证每个规则详情
                        for (
                            let i = 0;
                            i < this.addForm.ruleDetail.length;
                            i++
                        ) {
                            const rule = this.addForm.ruleDetail[i];
                            if (!rule.province) {
                                this.$message({
                                    showClose: true,
                                    message: `第${i + 1}个规则未选择省份`,
                                    type: "error",
                                });
                                return;
                            }
                            if (!rule.discount || rule.discount <= 0) {
                                this.$message({
                                    showClose: true,
                                    message: `第${i + 1}个规则折扣设置无效`,
                                    type: "error",
                                });
                                return;
                            }
                            // 验证线性规则的流量和扣费字段
                            if (rule.type == 1) {
                                if (!rule.addFlow || rule.addFlow <= 0) {
                                    this.$message({
                                        showClose: true,
                                        message: `第${i + 1}个规则流量设置无效`,
                                        type: "error",
                                    });
                                    return;
                                }
                                if (
                                    !rule.deductMoney ||
                                    rule.deductMoney <= 0
                                ) {
                                    this.$message({
                                        showClose: true,
                                        message: `第${
                                            i + 1
                                        }个规则扣费金额设置无效`,
                                        type: "error",
                                    });
                                    return;
                                }
                            }
                        }
                        const allRules = [];

                        // 添加其他规则
                        for (
                            let i = 0;
                            i < this.addForm.ruleDetail.length;
                            i++
                        ) {
                            const rule = this.addForm.ruleDetail[i];
                            console.log(`规则${i + 1}数据:`, rule);
                            allRules.push(rule);
                        }

                        params.ruleDetail = JSON.stringify(allRules);
                    }

                    if (this.addForm.category == 0) {
                        console.log("默认");
                        params.type = this.addForm.type;
                        params.discount = this.addForm.discount;

                        // 线性规则时添加流量和扣费字段
                        if (this.addForm.type == 1) {
                            params.addFlow = this.addForm.addFlow;
                            params.deductMoney = this.addForm.deductMoney;
                        }

                        if (typeof this.addForm.ladderDetail === "string") {
                            //字符串的时候不转换了
                            params.ladderDetail = this.addForm.ladderDetail;
                        } else {
                            params.ladderDetail = JSON.stringify(
                                this.addForm.ladderDetail
                            );
                        }
                    }
                    addRule(params).then((res) => {
                        if (res.system_result_key == "0") {
                            this.$message({
                                showClose: true,
                                message: "新增成功",
                                type: "success",
                            });
                            this.dialogAddVisible = false;
                            this.getRuleList();
                        } else {
                            this.$message({
                                showClose: true,
                                message: res.system_result_message_key,
                                type: "error",
                            });
                        }
                    });
                } else {
                    return false;
                }
            });
        },
        formAddReset(formName) {
            this.$refs[formName].resetFields();
            this.addForm.category = 0;
            this.addForm.province = "";
            this.addForm.agentId = ""; // 重置代理商ID
            this.addForm.ruleDetail = [];
            this.addForm.ladderDetail = "";
            this.addForm.addFlow = ""; // 重置流量字段
            this.addForm.deductMoney = ""; // 重置扣费字段
        },
        getladderDetail(val) {
            if (val && Array.isArray(val) && val.length > 0) {
                // 如果是在编辑规则详情中的阶梯规则
                if (this.currentRuleIndex >= 0) {
                    console.log(
                        `保存阶梯详情到规则${this.currentRuleIndex + 2}:`,
                        val
                    );

                    // 确保ruleDetail数组存在
                    if (!this.addForm.ruleDetail[this.currentRuleIndex]) {
                        console.error(`规则${this.currentRuleIndex}不存在`);
                        return;
                    }

                    // 保存阶梯详情数据
                    this.addForm.ruleDetail[
                        this.currentRuleIndex
                    ].ladderDetail = val;

                    console.log(
                        `规则${this.currentRuleIndex + 2}保存后的数据:`,
                        this.addForm.ruleDetail[this.currentRuleIndex]
                    );
                    console.log("整个ruleDetail数组:", this.addForm.ruleDetail);

                    this.currentRuleIndex = -1; // 重置索引
                } else if (this.currentRuleIndex === -1) {
                    // 主表单的阶梯设置
                    console.log("保存阶梯详情到主表单:", val);
                    this.addForm.ladderDetail = val;
                    this.currentRuleIndex = -1; // 重置索引
                } else {
                    // 原有的阶梯设置逻辑
                    console.log("保存阶梯详情到原有位置:", val);
                    this.addForm.ladderDetail = val;
                }
            } else {
                console.warn("接收到的阶梯详情数据无效:", val);
            }

            this.dialogVisibleTwo = false;
        },
        showAddPrice() {
            this.dialogVisibleTwo = true;
            this.isEditTitle = "设置阶梯价格";
            this.isAdd = true;
            this.ladderDetail = this.addForm.ladderDetail
                ? JSON.parse(this.addForm.ladderDetail)
                : this.addForm.ladderDetail;
        },
        addRuler() {
            this.dialogAddVisible = true;
            this.addForm.name = "";
            this.addForm.type = "";
            this.addForm.discount = 1;
            this.addForm.category = 0;
            this.addForm.province = "";
            this.addForm.agentId = ""; // 重置代理商ID
            this.addForm.ruleDetail = [];
            this.addForm.ladderDetail = "";
            this.addForm.addFlow = ""; // 重置流量字段
            this.addForm.deductMoney = ""; // 重置扣费字段
            // this.$refs['addForm'].resetFields();
        },

        // 监听规则类型变化，自动创建第一个规则
        onCategoryChange() {
            if (this.addForm.category == 1) {
                // 如果选择卡池组，清空规则详情，等待用户手动添加
                this.addForm.ruleDetail = [];
                // 清空代理商
                this.addForm.agentId = "";
                this.addForm.type = "";
            } else {
                // 如果选择默认，清空规则详情和代理商
                this.addForm.ruleDetail = [];
                this.addForm.agentId = "";
                this.addForm.type = "";
            }
        },

        // 新增规则详情
        addRuleDetail() {
            // 确保ruleDetail是数组
            if (!Array.isArray(this.addForm.ruleDetail)) {
                this.addForm.ruleDetail = [];
            }

            const newRule = {
                type: "",
                discount: 1,
                province: "",
                ladderDetail: [],
                addFlow: "", // 新增：流量字段
                deductMoney: "", // 新增：扣费字段
            };
            console.log(this.addForm.ruleDetail);
            this.addForm.ruleDetail.push(newRule);
        },

        // 删除规则详情
        removeRuleDetail(index) {
            this.$confirm("确定要删除这个规则吗？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                this.addForm.ruleDetail.splice(index, 1);
            });
        },

        // 显示阶梯设置（针对规则详情中的阶梯规则）
        showLadderSetting(ruleIndex) {
            console.log("显示阶梯设置，规则索引:", ruleIndex);
            console.log("当前addForm.ruleDetail:", this.addForm.ruleDetail);

            this.dialogVisibleTwo = true;
            this.isEditTitle = "设置阶梯价格";
            this.isAdd = true;
            this.currentRuleIndex = ruleIndex; // 记录当前编辑的规则索引

            if (ruleIndex === -1) {
                // 主表单的阶梯设置
                console.log("编辑主表单的阶梯设置");
                this.ladderDetail = this.addForm.ladderDetail
                    ? JSON.parse(this.addForm.ladderDetail)
                    : [];
            } else {
                if (
                    this.addForm.ruleDetail[ruleIndex] &&
                    this.addForm.ruleDetail[ruleIndex].ladderDetail
                ) {
                    try {
                        this.ladderDetail = JSON.parse(
                            this.addForm.ruleDetail[ruleIndex].ladderDetail
                        );
                        console.log(
                            `规则${ruleIndex + 2}解析后的阶梯详情:`,
                            this.ladderDetail
                        );
                    } catch (e) {
                        console.error(
                            `解析规则${ruleIndex + 2}的阶梯详情失败:`,
                            e
                        );
                        this.ladderDetail = [];
                    }
                } else {
                    console.log(
                        `规则${ruleIndex + 2}没有阶梯详情数据，初始化为空数组`
                    );
                    this.ladderDetail = [];
                }
            }
            console.log("传递给ladderSetting组件的数据:", this.ladderDetail);
        },
        getDetail(data) {
            if (data.type == 1) {
                //规则详情 未做
            } else if (data.type == 2) {
                //规则详情 未做
                this.dialogVisibleTwo = true;
                this.isEditTitle = "查看规则详情";
                this.isAdd = false;
                console.log();
                this.ladderDetail = data.ladderDetail
                    ? JSON.parse(data.ladderDetail)
                    : [];
                console.log(this.ladderDetail);
            }
        },
        getRuleList() {
            let params = {
                pageSize: this.pageSize,
                pageNo: this.page,
            };
            Object.assign(params, this.formInline);
            getRuleList(params).then((res) => {
                /* 表格数据 */
                this.tabledata = res.rows;
                this.page = res.pageNo;
                this.pageSize = res.pageSize;
                this.total = res.total;
            });
        },
        handleSizeChange(size) {
            this.pageSize = size;
            this.getRuleList();
        },
        onPageChange(page) {
            this.page = page;
            this.getRuleList();
        },
        searchData() {
            this.page = 1;
            this.getRuleList();
        },
        getAgentForImportCard() {
            getAgentForImportCard()
                .then((res) => {
                    this.agentLists = res.map((value, index, arr) => {
                        return { value: value.id, label: value.agentThreeName };
                    });
                    this.agentLists.unshift({
                        value: "",
                        label: "请选择代理商",
                    });
                })
                .catch(() => {
                    this.agentLists = [];
                });
        },
    },
};
</script>

<style>
.right_agent {
    margin-right: 8px;
}
.rulerManagement .el-form-item__label {
    vertical-align: top;
}

/* 规则项样式 */
.rule-item {
    border: 1px solid #e4e7ed;
    border-radius: 4px;
    padding: 16px;
    margin-bottom: 16px;
    background-color: #fafafa;
}

.rule-item .el-divider {
    margin: 0 0 16px 0;
}

.rule-item .el-form-item {
    margin-bottom: 12px;
}

.rule-item .el-form-item:last-child {
    margin-bottom: 0;
}
</style>
